import React from 'react';
import { format, parseISO } from 'date-fns';
import '../styles/CustomMeetingRoom.css'

export default function StudentHome({ studentDetails, classes }) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Set to start of day

    const sortedClasses = [...classes]
        .filter(c => new Date(c.class_date) >= currentDate)
        .sort((a, b) => 
            new Date(a.class_date + 'T' + a.start_time) - new Date(b.class_date + 'T' + b.start_time)
        );

    const nextClass = sortedClasses[0];
    const upcomingClasses = sortedClasses.slice(0, 5);

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white shadow-md rounded-lg p-6">
                <h2 className="text-2xl font-semibold mb-4">Welcome, {studentDetails.full_name}!</h2>
                <p className="text-gray-600 mb-4">Here's a summary of your classes:</p>
                <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4">
                    <p className="font-bold">Next Class:</p>
                    {nextClass ? (
                        <>
                            <p>{nextClass.class_name}</p>
                            <p>{format(parseISO(nextClass.class_date), 'MMMM d, yyyy')}</p>
                            <p>{format(parseISO(`2000-01-01T${nextClass.start_time}`), 'h:mm a')} - {format(parseISO(`2000-01-01T${nextClass.end_time}`), 'h:mm a')}</p>
                        </>
                    ) : (
                        <p>No upcoming classes scheduled.</p>
                    )}
                </div>
                <div className="space-y-2">
                    <p className="text-gray-600">Total Classes: <span className="font-semibold">{classes.length}</span></p>
                    <p className="text-gray-600">Teacher Name: <span className="font-semibold">{classes[0]?.teachers?.full_name || 'N/A'}</span></p>
                    <p className="text-gray-600">Teacher Number: <span className="font-semibold">{classes[0]?.teachers?.phone_number || 'N/A'}</span></p>
                    <p className="text-gray-600">Date of Next Class: <span className="font-semibold">
                        {nextClass ? format(parseISO(nextClass.class_date), 'MMMM d, yyyy') : 'N/A'}
                    </span></p>
                </div>
            </div>
            <div className="bg-white shadow-md rounded-lg p-6">
                <h2 className="text-2xl font-semibold mb-4">Upcoming Class Schedule</h2>
                <div className="space-y-4">
                    {upcomingClasses.map((classItem, index) => (
                        <div key={index} className="border-b pb-2 last:border-b-0">
                            <p className="font-semibold">{classItem.class_name}</p>
                            <p className="text-sm text-gray-600">{format(parseISO(classItem.class_date), 'MMMM d, yyyy')}</p>
                            <p className="text-sm text-gray-600">
                                {format(parseISO(`2000-01-01T${classItem.start_time}`), 'h:mm a')} - 
                                {format(parseISO(`2000-01-01T${classItem.end_time}`), 'h:mm a')}
                            </p>
                        </div>
                    ))}
                </div>
                
            </div>
        </div>
    );
}